<div class="w-full">
  <div class="flex justify-content-between align-items-center py-2 w-full pr-2">
    <h2 class="m-0 font-medium text-4xl section-title">{{ 'usage' | translate }}</h2>
    <p-button
      tooltipPosition="bottom"
      severity="primary"
      icon="fa-solid fa-clock-rotate-left"
      class="flex align-items-center"
      [ariaLabel]="'contractList' | translate"
      [pTooltip]="'selectContract' | translate"
      [attr.aria-haspopup]="'true'"
      [attr.aria-expanded]="contractList.visible || false"
      [outlined]="true"
      (click)="contractList.toggle($event)"
    >
    </p-button>
  </div>
  <div class="border-bottom-1 border-500 w-full mb-3"></div>

  <div class="w-full px-2">
    <div class="grid">
      <div class="col-12">
        <app-contract-usages
          [isMeterDataLoading]="state.isMeterDataLoading"
          [isMeterDataEmpty]="state.isMeterDataEmpty"
          [pagesExtractedTotal]="state.pagesExtractedTotal"
          [yearlyPageExtractionQuota]="state.yearlyPageExtractionQuota"
          [meterGrouptotalPercent]="state.meterGrouptotalPercent"
          [selectedContractRange]="state.selectedContractRange"
          [selectedPeriodLabel]="state.selectedPeriodLabel"
          [hasExceededQuota]="state.hasExceededQuota"
          [meterColor]="meterColor"
        >
        </app-contract-usages>
      </div>
      <div class="col-6">
        <p-card class="w-full">
          @if (state.aggregateDataloading) {
            <div class="flex justify-content-center align-items-center p-4">
              <p-progress-spinner
                ariaLabel="loading"
                class="w-2rem h-2rem"
              />
            </div>
          } @else {
            @if (data.aggregateData) {
              <div class="flex justify-content-between align-items-start pb-3">
                <h3 class="text-xl font-normal m-0">
                  {{ 'monthlyScans' | translate }}
                  <span class="pl-2 text-sm text-600"> {{ state.selectedPeriodLabel }} </span>
                </h3>
              </div>
              <app-monthly-scans [meteringData]="data.aggregateData"></app-monthly-scans>
            }
          }
        </p-card>
      </div>
    </div>
  </div>

  <p-menu
    #contractList
    appendTo="body"
    class="sd-contract-dropdown"
    [popup]="true"
    [model]="data.menuItems"
  >
    <ng-template
      let-item
      pTemplate="item"
    >
      <button
        class="p-menuitem-link"
        type="button"
        tabindex="0"
        [ngClass]="{ 'selected-menu-item': item.selected }"
        [attr.aria-label]="item.label"
        (click)="item.command ? item.command() : null"
        (keydown.enter)="item.command ? item.command() : null"
        (keydown.space)="item.command ? item.command() : null"
      >
        <span
          class="p-menuitem-icon"
          aria-hidden="true"
          [ngClass]="item.icon"
        ></span>
        <span class="p-menuitem-text">{{ item.label }}</span>
      </button>
    </ng-template>
  </p-menu>
</div>
